module.exports = __webpack_public_path__ + "static/media/hall-PD.d333ccb5.svg";